import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'
import { languageChange, deleteAccount, updateAlias } from 'store/siteConfig'

export default function(route) {
  const MobileNumber = Loadable({
    loader: () => import('./MobileNumber'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          topUpMobileNumberState: state.topUpMobileNumberState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          deleteAccount,
          languageChange,
          updateAlias
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/mobile-number`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <MobileNumber {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
